import { axiosInstance as Axios } from "@/main";

export default {
  state: {
    logoBase64: null,
    styling: [],
    goBack: false
  },
  mutations: {
    set_logo_base64(state, payload) {
      state.logoBase64 = payload;
    },
    set_styling(state, payload) {
      state.styling = payload;
    },
    setGoBack(state, payload) {
      state.goBack = payload;
    }
  },
  actions: {
    async load_logo_base64(state, { id }) {
      try {
        let result = await Axios.get("configs/logo", {
          headers: { "X-Organizacao-ID": id }
        });
        state.commit("set_logo_base64", result.data);
      } catch (e) {
        console.log(e);
      }
    },
    async load_styling(state, url) {
      try {
        let result = await Axios.get(url);
        state.commit("set_styling", result.data);
      } catch (e) {
        console.log(e);
      }
    },
    setGoBack(store, payload) {
      store.commit("setGoBack", payload);
    }
  },
  getters: {
    get_logoImage(state) {
      return `data:image/png; base64, ${state.logoBase64}`;
    }
  }
};
